import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CUSTOM_MATERIAL_ICON_NAMES } from '@core/constants/custom-material-icon-names';

@Injectable({
  providedIn: 'root'
})
export class CustomMaterialIconService {

  constructor(private _iconRegistry: MatIconRegistry, private _sanitizer: DomSanitizer) {
  }
  
  registerCustomIcons() {
    CUSTOM_MATERIAL_ICON_NAMES.forEach(iconName => {
      this._iconRegistry.addSvgIcon(
        iconName,
        this._sanitizer.bypassSecurityTrustResourceUrl(`assets/images/icons/${iconName}.svg`)
      );
    });
  }
}
